import { DatePicker, TimePicker, TimePickerProps } from 'antd';
import React, { useEffect, useState } from 'react'
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs, { Dayjs } from "dayjs";
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../core/common/textFields/TextField';
import { useGetAllActiveUsersQuery, useGetSaleInfoByIdQuery, useLazyGetSaleInfoByIdQuery, useUpsertSaleInfoDetailsMutation } from '../../../../services/EndPointsApis';
import { useFormik } from 'formik';
import { initialValuesSale } from '../../Projects/SaleWizardData/InitialValuesSalesWizard';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import DateComp from '../../../../core/common/dateComponent/DateComp';
import { CSVLink } from 'react-csv';
import FormattedNumber from '../../../../core/common/textFields/FormatNumber';
import TableLoading from '../../../../core/common/loadingComponent/TableLoading';
import DateTimeComp from '../../../../core/common/dateComponent/DateTimeComp';


const PaymentReceived = ({ projectId }: any) => {

    dayjs.extend(customParseFormat);

    //Get Sale Info
    const { data: saleInfoData, refetch, isFetching } = useGetSaleInfoByIdQuery({ ProjectId: projectId })
    useEffect(() => {
        refetch()
    }, []);

    const formatComma = (num: number | string) => {
        if (num === null || num === undefined) return "0.0";
        const numericValue = String(num).replace(/,/g, "");
        if (isNaN(Number(numericValue))) return String(num);
        return Number(numericValue).toLocaleString();
    };

    const totalAmount = saleInfoData?.result?.projectPaymentReceivableList?.projectPaymentReceivable?.reduce((sum: any, item: any) =>
        sum + (item?.amount || 0),
        0
    ) || 0

    const totalCount = saleInfoData?.result?.projectPaymentReceivableList?.projectPaymentReceivable?.reduce((sum: any, item: any) =>
        sum + 1,
        0
    ) || 0

    const headers = [
        { label: "Date", key: "dateCreatedInTB" },
        { label: "Payment Description", key: "description" },
        { label: "Amount", key: "amount" }
    ];

    const csvData = saleInfoData?.result?.projectPaymentReceivableList?.projectPaymentReceivable?.map((item: any) => ({
        dateCreatedInTB: new Date(item.transcationDate).toLocaleDateString(),
        description: item.description,
        amount: formatComma(item.amount ?? '0.0')
    })) || [];
    return (
        <>
            <div className='row'>
                <div className='col-md-8'>
                    {/* table  */}
                    <div className='card'>
                        <div className='card-body card-css'>
                            <div className='d-flex'>
                                <div className='w-35'>
                                    <p className='mb-0'>Last Timberline Sync: </p>
                                </div>
                                <div>
                                    {' '}  <DateTimeComp formattedDate={saleInfoData?.result?.projectPaymentReceivableList?.lstTimberLineSync} />
                                </div>
                            </div>
                            <div className='d-flex'>
                                <div className='w-35'>
                                    <p className='mb-0'>Last AR entry in Timberline:</p>
                                </div>
                                <div>
                                    {' '} <DateTimeComp formattedDate={saleInfoData?.result?.projectPaymentReceivableList?.lstApEntryInTimberLine} />
                                </div>
                            </div>
                            <div className='d-flex justify-content-end'>
                                <CSVLink data={csvData} headers={headers} filename={`Payment Received.csv`} className="btn btn-light-red d-flex justify-content-center gap-1 align-items-center">
                                    <i className="fa fa-file-export" />
                                    Export To CSV
                                </CSVLink>
                            </div>
                            <div className="table-responsive mt-2 overflow-auto saleInfoTableHeight">
                                <table className="table datanew dataTable no-footer table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                Date
                                            </th>
                                            <th>
                                                Payment Description
                                            </th>
                                            <th className='text-end'>
                                                Amount
                                            </th>
                                        </tr>
                                    </thead>
                                    {isFetching ?
                                        <tr>
                                            <td colSpan={5} className='text-center'>
                                                <TableLoading />
                                            </td>
                                        </tr>
                                        :
                                        <tbody>
                                            {saleInfoData?.result?.projectPaymentReceivableList?.projectPaymentReceivable?.map((item: any, index: any) => (
                                                <tr key={item.id}>
                                                    <td><DateComp formattedDate={item?.transcationDate} /></td>
                                                    <td>{item?.description}</td>
                                                    <td className='text-end'>
                                                        <FormattedNumber value={item.amount} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    }
                                </table>
                            </div>
                            <div className='row'>
                                <div className='col-md-5 pt-4 text-end'>
                                    <h6 className='color-red'> Count : {totalCount}</h6>
                                </div>
                                <div className='col-md-7 pt-4 text-end'>
                                    <h6 className='color-red mr-15'><FormattedNumber value={totalAmount} /></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5 className='mb-2 mt-2'>Payment Received</h5>
                            <div className="col-md-12 mb-2">
                                <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                        Total Contract Amount
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={saleInfoData?.result?.totalContractAmt} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-2">
                                <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                        Total Payment Received
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={totalAmount} />
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-12'></div>
                            <div className="col-md-12 mt-2 w-100 d-flex justify-content-end ">
                                <div className='br-gray py-2 px-3 w-50'>
                                    <p className='color-red fs-15 fw-600 text-end'> {<FormattedNumber value={(saleInfoData?.result?.totalContractAmt) - (totalAmount)} />}</p>
                                </div>

                            </div>
                            {/* {parseFloat(remainingAmount.replace(/,/g, '')) < 0 && (
                                <p className="color-red fw-semibold d-flex justify-content-end">
                                    Negative amount not considered
                                </p>
                            )} */}
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default PaymentReceived